import React, { useState } from 'react';

import { consts, internalUnits } from '../utils/consts';

export const defaultTargets = Object.freeze({
  top: consts[internalUnits].ticks.high,
  bottom: consts[internalUnits].ticks.low,
});

const defaultState = Object.freeze({
  targets: defaultTargets,
  setTargets: f => f,
});

const TargetContext = React.createContext(defaultState);

export function TargetContextProvider({ children }) {
  const [targets, setTargets] = useState(defaultTargets);

  const state = {
    targets,
    setTargets,
  };

  return (
    <TargetContext.Provider value={state}>
      {children}
    </TargetContext.Provider>
  );
}

export default TargetContext;
